import { v4 } from "uuid";
import { LOCAL_STORAGE_KEY } from "./local-storage";

// define a unique id for the service worker as a device id
export const getDeviceId = () => {
  if (!localStorage.getItem(LOCAL_STORAGE_KEY.deviceId)) {
    localStorage.setItem(LOCAL_STORAGE_KEY.deviceId, v4());
  }
  return localStorage.getItem(LOCAL_STORAGE_KEY.deviceId)!;
};

export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      let registration = await navigator.serviceWorker.getRegistration("/web/");
      if (registration) {
        console.log("Service Worker already registered:", registration);
        return registration;
      }
      registration = await navigator.serviceWorker.register(
        `${window.location.origin}/web/firebase-messaging-sw.js`,
        {
          scope: "/web/",
        },
      );
      console.log("Service Worker registered with scope:", registration.scope);
      return registration;
    } catch (error) {
      console.error("Service Worker registration failed:", error);
      throw error; // Re-throw to handle in the calling code
    }
  } else {
    console.warn("Service Workers not supported in this browser");
    return null;
  }
};
